import React from 'react';
import TaskAssignment from './TaskAssignment';

function TaskAssigneesList(props) {
    const { event, session } = props,
        { is_task, assignees } = session;

    if (!is_task) return null;
    if (!assignees.length) return null;

    return (
        <div className="content ">
            {assignees.map((assignment, i) => {
                return <TaskAssignment className="marginTop marginBottom" key={i} event={event} assignment={assignment} />
            })}
        </div>
    );
}

export default TaskAssigneesList;
